import React from 'react';
import {
  Avatar,
  Box,
  makeStyles,
  Typography,
  Modal,
  Container,
  IconButton,
  Table,
  TableRow,
  TableBody,
  TableCell
} from '@material-ui/core';
import StarIcon from '@mui/icons-material/Star';
import PropTypes from 'prop-types';
import { map, range, includes, get } from 'lodash';
import ElementBackgroundAssets from '../constants/ElementBackgroundAssets';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import numeral from 'numeral';
import { ARTIFACT_STAT_TO_TEXT, ASSET_URL } from '../constants/index';
import LockIcon from '@mui/icons-material/Lock';
import EnkaIcon from '../assets/3rdparty/Enka.Network.png';
import { useSelector } from 'react-redux';
import _ from 'lodash';

const useStyles = makeStyles(theme => ({
  '@keyframes pulsate': {
    '0%': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)'
    },
    '50%': {
      backgroundColor: 'rgba(255, 255, 255, 0.6)'
    },
    '100%': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)'
    }
  },
  characterImage: {
    width: '5rem !important',
    height: '5rem !important',
    backgroundColor: theme.palette.text.primary,
    margin: '0.5rem',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.text.secondary
    }
  },
  characterImagePopup: {
    width: '7rem !important',
    height: '7rem !important',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    margin: '0.5rem'
  },
  text: {},
  popupModal: {
    position: 'fixed',
    // top: '50%',
    // left: '50%',
    // transform: 'translate(-50%, -50%)',
    border: 'none',
    flexDirection: 'column',
    overflow: 'auto',
    width: '100%',
    height: '100%',
    display: 'grid',
    placeItems: 'center',
    margin: 0,
    padding: 0
  },
  popupContent: {
    width: '1400px',
    height: '800px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
    padding: '2rem',
    borderRadius: '5px',
    color: 'white',
    position: 'relative',
    overflow: 'hidden'
  },
  modalRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  exitModalButton: {
    '&:hover': {
      color: theme.palette.text.secondary
    },
    marginLeft: 'auto',
    alignSelf: 'flex-start'
  },
  constellation: {
    animation: '$pulsate 3s ease-in-out infinite'
  },
  inactiveConstellation: {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    opacity: 0.3
  },
  characterTableContainer: {
    overflowY: 'auto',
    width: 'fit-content',
    height: '280px'
  },
  characterTable: {
    width: '800px'
  },
  tableBody: {
    '& tr:nth-child(odd)': {
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
      color: theme.palette.background.paper
    },
    '& tr:nth-child(even)': {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      color: theme.palette.background.paper
    }
  },
  characterCell: {
    color: 'white',
    border: 'none',
    fontSize: '18px'
  },
  weaponStats: {
    display: 'flex',
    flexDirection: 'column'
  },
  artifact: {
    borderRadius: '5px',
    width: '185px',
    height: '170px',
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    marginRight: '1rem',
    position: 'relative',
    padding: '0.3rem'
  },
  artifactImg: {
    width: '50px',
    height: '50px',
    position: 'absolute',
    top: 0,
    left: 0,
    transform: 'translate(0, -50%)',
    objectFit: 'scale-down'
  },
  artifactHeader: {
    width: '100%',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    transform: 'translate(0%, -50%)'
  },
  star: {
    color: theme.palette.secondary.main
  },
  weaponCard: {
    height: 'fit-content',
    width: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0.5rem',
    marginRight: '3rem'
  },
  substats: {
    width: '100%',
    height: 'fit-content',
    display: 'flex',
    flexDirection: 'column',
    padding: '0.2rem'
  },
  lockActive: {
    display: 'initial'
  },
  lockInactive: {
    display: 'none !important'
  },
  weaponImg: {
    objectFit: 'scale-down'
  },
  rightBar: {
    height: '100%',
    width: '10%',
    position: 'absolute',
    paddingTop: '80px',
    top: 0,
    right: 0
  }
}));

function CharacterSnapshotModal(props) {
  const classes = useStyles();

  const pyroShift = -12;
  const geoShift = -20;
  const hydroShift = -20;

  function handleClose() {
    props.handleClose();
  }

  const characterAssets = useSelector(
    state => state.gameAssets.characterAssets
  );

  const weaponAssets = useSelector(state => state.gameAssets.weaponAssets);

  const artifactAssets = useSelector(state => state.gameAssets.artifactAssets);

  return (
    <Modal
      open={props.open}
      onClose={handleClose}
      aria-labelledby="character-information-modal"
    >
      <Container classes={{ root: classes.popupModal }} maxWidth={false}>
        <Box
          classes={{ root: classes.popupContent }}
          style={{
            backgroundImage: `url(${ElementBackgroundAssets[
              props.modalContent.element
            ] ?? ''})`,
            backgroundColor: 'grey'
          }}
        >
          <Box className={classes.rightBar}>{props.rightBar ?? null}</Box>
          <Box classes={{ root: classes.modalRow }}>
            <Avatar
              src={get(
                _.find(characterAssets, { name: props.modalContent.name }),
                'avatar'
              )}
              alt={props.modalContent.name}
              className={classes.characterImagePopup}
              style={{ marginRight: '2rem' }}
            />
            <Typography variant="h1">{props.modalContent.name}</Typography>
            <Typography variant="h2" style={{ marginLeft: '2rem' }}>
              Lv. {props.modalContent.level}
            </Typography>
            <Typography variant="h2" style={{ marginLeft: '2rem' }}>
              Friendship Lv. {props.modalContent.friendship_level}
            </Typography>
            <IconButton
              aria-label="close"
              color="inherit"
              onClick={handleClose}
              classes={{ root: classes.exitModalButton }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Box>
          {props.modalContent.weapon && (
            <Box classes={{ root: classes.modalRow }}>
              <Box classes={{ root: classes.weaponCard }}>
                <Box
                  component="img"
                  classes={{ root: classes.weaponImg }}
                  sx={{
                    width: '65px',
                    height: '95px',
                    margin: '1rem'
                  }}
                  src={`${ASSET_URL}/${get(
                    _.find(weaponAssets, {
                      name: props.modalContent.weapon.weaponName
                    }),
                    'icon'
                  )}.png`}
                  alt={props.modalContent.weapon.weaponName}
                />
                <Box classes={{ root: classes.weaponStats }}>
                  <Typography variant="h4" style={{ fontWeight: 'bold' }}>
                    {props.modalContent.weapon.weaponName} R
                    {props.modalContent.weapon.refine}
                  </Typography>
                  <Box mt={2} />
                  <Typography variant="h4">
                    Lv. {props.modalContent.weapon.level}
                  </Typography>
                </Box>
              </Box>
              <Box
                component="img"
                src={get(
                  _.find(characterAssets, { name: props.modalContent.name }),
                  'normal_attack_talent'
                )}
                style={{
                  marginLeft: '2rem',
                  width: '50px',
                  height: 'auto'
                }}
                alt="NA Level"
              />
              <Typography variant="h5" style={{ marginLeft: '1rem' }}>
                Lv. {props.modalContent.normal_attack_level}
              </Typography>
              <Box
                component="img"
                src={get(
                  _.find(characterAssets, { name: props.modalContent.name }),
                  'elemental_skill_talent'
                )}
                style={{
                  marginLeft: '2rem',
                  width: '50px',
                  height: 'auto'
                }}
                alt="Skill Level"
              />
              <Typography variant="h5" style={{ marginLeft: '1rem' }}>
                Lv. {props.modalContent.elemental_skill_level}
              </Typography>
              <Box
                component="img"
                src={get(
                  _.find(characterAssets, { name: props.modalContent.name }),
                  'elemental_burst_talent'
                )}
                style={{
                  marginLeft: '2rem',
                  width: '50px',
                  height: 'auto'
                }}
                alt="Burst Level"
              />
              <Typography variant="h5" style={{ marginLeft: '1rem' }}>
                Lv. {props.modalContent.elemental_burst_level}
              </Typography>
            </Box>
          )}
          <Box classes={{ root: classes.modalRow }}>
            <Box classes={{ root: classes.characterTableContainer }}>
              <Table classes={{ root: classes.characterTable }} size="small">
                <TableBody classes={{ root: classes.tableBody }}>
                  <TableRow classes={{ root: classes.row }}>
                    <TableCell classes={{ root: classes.characterCell }}>
                      Max HP
                    </TableCell>
                    <TableCell
                      style={{ textAlign: 'center' }}
                      classes={{ root: classes.characterCell }}
                    >
                      {numeral(props.modalContent.health).format('0,0')}
                    </TableCell>
                  </TableRow>
                  <TableRow classes={{ root: classes.row }}>
                    <TableCell classes={{ root: classes.characterCell }}>
                      ATK
                    </TableCell>
                    <TableCell
                      style={{ textAlign: 'center' }}
                      classes={{ root: classes.characterCell }}
                    >
                      {numeral(props.modalContent.attack).format('0,0')}
                    </TableCell>
                  </TableRow>
                  <TableRow classes={{ root: classes.row }}>
                    <TableCell classes={{ root: classes.characterCell }}>
                      DEF
                    </TableCell>
                    <TableCell
                      style={{ textAlign: 'center' }}
                      classes={{ root: classes.characterCell }}
                    >
                      {numeral(props.modalContent.defense).format('0,0')}
                    </TableCell>
                  </TableRow>
                  <TableRow classes={{ root: classes.row }}>
                    <TableCell classes={{ root: classes.characterCell }}>
                      Elemental Mastery
                    </TableCell>
                    <TableCell
                      style={{ textAlign: 'center' }}
                      classes={{ root: classes.characterCell }}
                    >
                      {numeral(props.modalContent.elemental_mastery).format(
                        '0,0'
                      )}
                    </TableCell>
                  </TableRow>
                  <TableRow classes={{ root: classes.row }}>
                    <TableCell classes={{ root: classes.characterCell }}>
                      CRIT Rate
                    </TableCell>
                    <TableCell
                      style={{ textAlign: 'center' }}
                      classes={{ root: classes.characterCell }}
                    >
                      {numeral(props.modalContent.critical_strike_rate).format(
                        '0.00%'
                      )}
                    </TableCell>
                  </TableRow>
                  <TableRow classes={{ root: classes.row }}>
                    <TableCell classes={{ root: classes.characterCell }}>
                      CRIT DMG
                    </TableCell>
                    <TableCell
                      style={{ textAlign: 'center' }}
                      classes={{ root: classes.characterCell }}
                    >
                      {numeral(
                        props.modalContent.critical_strike_multiplier
                      ).format('0.00%')}
                    </TableCell>
                  </TableRow>
                  <TableRow classes={{ root: classes.row }}>
                    <TableCell classes={{ root: classes.characterCell }}>
                      Energy Recharge
                    </TableCell>
                    <TableCell
                      style={{ textAlign: 'center' }}
                      classes={{ root: classes.characterCell }}
                    >
                      {numeral(props.modalContent.energy_recharge).format(
                        '0.00%'
                      )}
                    </TableCell>
                  </TableRow>
                  {!!props.modalContent.cryo_damage_bonus && (
                    <TableRow classes={{ root: classes.row }}>
                      <TableCell classes={{ root: classes.characterCell }}>
                        Cryo DMG Bonus
                      </TableCell>
                      <TableCell
                        style={{ textAlign: 'center' }}
                        classes={{ root: classes.characterCell }}
                      >
                        {numeral(props.modalContent.cryo_damage_bonus).format(
                          '0.00%'
                        )}
                      </TableCell>
                    </TableRow>
                  )}
                  {!!props.modalContent.pyro_damage_bonus && (
                    <TableRow classes={{ root: classes.row }}>
                      <TableCell classes={{ root: classes.characterCell }}>
                        Pyro DMG Bonus
                      </TableCell>
                      <TableCell
                        style={{ textAlign: 'center' }}
                        classes={{ root: classes.characterCell }}
                      >
                        {numeral(props.modalContent.pyro_damage_bonus).format(
                          '0.00%'
                        )}
                      </TableCell>
                    </TableRow>
                  )}
                  {!!props.modalContent.physical_damage_bonus && (
                    <TableRow classes={{ root: classes.row }}>
                      <TableCell classes={{ root: classes.characterCell }}>
                        Physical DMG Bonus
                      </TableCell>
                      <TableCell
                        style={{ textAlign: 'center' }}
                        classes={{ root: classes.characterCell }}
                      >
                        {numeral(
                          props.modalContent.physical_damage_bonus
                        ).format('0.00%')}
                      </TableCell>
                    </TableRow>
                  )}
                  {!!props.modalContent.geo_damage_bonus && (
                    <TableRow classes={{ root: classes.row }}>
                      <TableCell classes={{ root: classes.characterCell }}>
                        Geo DMG Bonus
                      </TableCell>
                      <TableCell
                        style={{ textAlign: 'center' }}
                        classes={{ root: classes.characterCell }}
                      >
                        {numeral(props.modalContent.geo_damage_bonus).format(
                          '0.00%'
                        )}
                      </TableCell>
                    </TableRow>
                  )}
                  {!!props.modalContent.electro_damage_bonus && (
                    <TableRow classes={{ root: classes.row }}>
                      <TableCell classes={{ root: classes.characterCell }}>
                        Electro DMG Bonus
                      </TableCell>
                      <TableCell
                        style={{ textAlign: 'center' }}
                        classes={{ root: classes.characterCell }}
                      >
                        {numeral(
                          props.modalContent.electro_damage_bonus
                        ).format('0.00%')}
                      </TableCell>
                    </TableRow>
                  )}
                  {!!props.modalContent.dendro_damage_bonus && (
                    <TableRow classes={{ root: classes.row }}>
                      <TableCell classes={{ root: classes.characterCell }}>
                        Dendro DMG Bonus
                      </TableCell>
                      <TableCell
                        style={{ textAlign: 'center' }}
                        classes={{ root: classes.characterCell }}
                      >
                        {numeral(props.modalContent.dendro_damage_bonus).format(
                          '0.00%'
                        )}
                      </TableCell>
                    </TableRow>
                  )}
                  {!!props.modalContent.anemo_damage_bonus && (
                    <TableRow classes={{ root: classes.row }}>
                      <TableCell classes={{ root: classes.characterCell }}>
                        Anemo DMG Bonus
                      </TableCell>
                      <TableCell
                        style={{ textAlign: 'center' }}
                        classes={{ root: classes.characterCell }}
                      >
                        {numeral(props.modalContent.anemo_damage_bonus).format(
                          '0.00%'
                        )}
                      </TableCell>
                    </TableRow>
                  )}
                  {!!props.modalContent.hydro_damage_bonus && (
                    <TableRow classes={{ root: classes.row }}>
                      <TableCell classes={{ root: classes.characterCell }}>
                        Hydro DMG Bonus
                      </TableCell>
                      <TableCell
                        style={{ textAlign: 'center' }}
                        classes={{ root: classes.characterCell }}
                      >
                        {numeral(props.modalContent.hydro_damage_bonus).format(
                          '0.00%'
                        )}
                      </TableCell>
                    </TableRow>
                  )}
                  {!!props.modalContent.healing_bonus && (
                    <TableRow classes={{ root: classes.row }}>
                      <TableCell classes={{ root: classes.characterCell }}>
                        Healing Bonus
                      </TableCell>
                      <TableCell
                        style={{ textAlign: 'center' }}
                        classes={{ root: classes.characterCell }}
                      >
                        {numeral(props.modalContent.healing_bonus).format(
                          '0.00%'
                        )}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Box>
          </Box>
          <Box mt={4} />
          <Box classes={{ root: classes.modalRow }}>
            {map(props.modalContent.artifacts, (artifact, idx) => {
              return (
                <Box classes={{ root: classes.artifact }} key={idx}>
                  <Box
                    component="img"
                    src={`${ASSET_URL}/${get(
                      _.find(artifactAssets, {
                        setName: artifact.set,
                        slot: artifact.slot
                      }),
                      'icon'
                    )}.png`}
                    classes={{ root: classes.artifactImg }}
                  />
                  <Box
                    classes={{ root: classes.artifactHeader }}
                    style={{ paddingLeft: '3rem' }}
                  >
                    {range(0, props.modalContent.artifacts.length).map(idx => {
                      return (
                        <StarIcon key={idx} classes={{ root: classes.star }} />
                      );
                    })}
                  </Box>
                  <Typography
                    style={{
                      position: 'absolute',
                      top: '-30px',
                      left: '3rem'
                    }}
                    variant="h5"
                  >
                    Lv. {artifact.level}
                  </Typography>
                  <Box mt={2.5} />
                  <Typography variant="h5" style={{ fontWeight: 'bold' }}>
                    {ARTIFACT_STAT_TO_TEXT[artifact.mainStatType]}
                  </Typography>
                  <Typography variant="h6">
                    {includes(artifact.mainStatType, 'Bonus') ||
                    includes(artifact.mainStatType, 'Percentage') ||
                    includes(artifact.mainStatType, 'Critical') ||
                    includes(artifact.mainStatType, 'Recharge')
                      ? numeral(artifact.mainStatValue / 100).format('0.00%')
                      : numeral(artifact.mainStatValue).format('0,0')}
                  </Typography>
                  <Box classes={{ root: classes.substats }}>
                    {map(artifact.substats, (substat, idx) => {
                      return (
                        <Box
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between'
                          }}
                          key={idx}
                        >
                          <Typography
                            variant="h6"
                            style={{
                              fontWeight: 'bold',
                              width: '70%'
                            }}
                          >
                            {ARTIFACT_STAT_TO_TEXT[substat.type]}{' '}
                          </Typography>
                          <Box
                            style={{
                              flexGrow: 1,
                              display: 'flex',
                              justifyContent: 'center'
                            }}
                          >
                            <Typography variant="h6">
                              {includes(substat.type, 'Bonus') ||
                              includes(substat.type, 'Percentage') ||
                              includes(substat.type, 'Critical') ||
                              includes(substat.type, 'Recharge')
                                ? numeral(substat.value / 100).format('0.00%')
                                : numeral(substat.value).format('0,0')}
                            </Typography>
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              );
            })}
          </Box>
          <Avatar
            style={{
              height: '45px',
              width: '45px',
              position: 'absolute',
              right: '265px',
              top: `${200 +
                (props.modalContent.element === 'Pyro' ? pyroShift : 0) +
                (props.modalContent.element === 'Geo' ? geoShift : 0) +
                (props.modalContent.element === 'Hydro' ? hydroShift : 0)}px`
            }}
            classes={{
              root: clsx({
                [classes.constellation]: props.modalContent.constellation >= 1,
                [classes.inactiveConstellation]:
                  props.modalContent.constellation < 1
              })
            }}
            src={get(
              _.find(characterAssets, { name: props.modalContent.name }),
              'constellation_1',
              'google'
            )}
            alt="1"
          />
          <LockIcon
            style={{
              height: '45px',
              width: '45px',
              position: 'absolute',
              right: '265px',
              top: `${200 +
                (props.modalContent.element === 'Pyro' ? pyroShift : 0) +
                (props.modalContent.element === 'Geo' ? geoShift : 0) +
                (props.modalContent.element === 'Hydro' ? hydroShift : 0)}px`
            }}
            classes={{
              root: clsx({
                [classes.lockInactive]: props.modalContent.constellation >= 1,
                [classes.lockActive]: props.modalContent.constellation < 1
              })
            }}
          />
          <Avatar
            style={{
              height: '45px',
              width: '45px',
              position: 'absolute',
              right: '226px',
              top: `${282 +
                (props.modalContent.element === 'Pyro' ? pyroShift : 0) +
                (props.modalContent.element === 'Geo' ? geoShift : 0) +
                (props.modalContent.element === 'Hydro' ? hydroShift : 0)}px`
            }}
            classes={{
              root: clsx({
                [classes.constellation]: props.modalContent.constellation >= 2,
                [classes.inactiveConstellation]:
                  props.modalContent.constellation < 2
              })
            }}
            src={get(
              _.find(characterAssets, { name: props.modalContent.name }),
              'constellation_2',
              'google'
            )}
            alt="2"
          />
          <LockIcon
            style={{
              height: '45px',
              width: '45px',
              position: 'absolute',
              right: '226px',
              top: `${282 +
                (props.modalContent.element === 'Pyro' ? pyroShift : 0) +
                (props.modalContent.element === 'Geo' ? geoShift : 0) +
                (props.modalContent.element === 'Hydro' ? hydroShift : 0)}px`
            }}
            classes={{
              root: clsx({
                [classes.lockInactive]: props.modalContent.constellation >= 2,
                [classes.lockActive]: props.modalContent.constellation < 2
              })
            }}
          />
          <Avatar
            style={{
              height: '45px',
              width: '45px',
              position: 'absolute',
              right: '200px',
              top: `${365 +
                (props.modalContent.element === 'Pyro' ? pyroShift : 0) +
                (props.modalContent.element === 'Geo' ? geoShift : 0) +
                (props.modalContent.element === 'Hydro' ? hydroShift : 0)}px`
            }}
            classes={{
              root: clsx({
                [classes.constellation]: props.modalContent.constellation >= 3,
                [classes.inactiveConstellation]:
                  props.modalContent.constellation < 3
              })
            }}
            src={get(
              _.find(characterAssets, { name: props.modalContent.name }),
              'constellation_3',
              'google'
            )}
            alt="3"
          />
          <LockIcon
            style={{
              height: '45px',
              width: '45px',
              position: 'absolute',
              right: '200px',
              top: `${365 +
                (props.modalContent.element === 'Pyro' ? pyroShift : 0) +
                (props.modalContent.element === 'Geo' ? geoShift : 0) +
                (props.modalContent.element === 'Hydro' ? hydroShift : 0)}px`
            }}
            classes={{
              root: clsx({
                [classes.lockInactive]: props.modalContent.constellation >= 3,
                [classes.lockActive]: props.modalContent.constellation < 3
              })
            }}
          />
          <Avatar
            style={{
              height: '45px',
              width: '45px',
              position: 'absolute',
              right: '200px',
              top: `${447 +
                (props.modalContent.element === 'Pyro' ? pyroShift : 0) +
                (props.modalContent.element === 'Geo' ? geoShift : 0) +
                (props.modalContent.element === 'Hydro' ? hydroShift : 0)}px`
            }}
            classes={{
              root: clsx({
                [classes.constellation]: props.modalContent.constellation >= 4,
                [classes.inactiveConstellation]:
                  props.modalContent.constellation < 4
              })
            }}
            src={get(
              _.find(characterAssets, { name: props.modalContent.name }),
              'constellation_4',
              'google'
            )}
            alt="4"
          />
          <LockIcon
            style={{
              height: '45px',
              width: '45px',
              position: 'absolute',
              right: '200px',
              top: `${447 +
                (props.modalContent.element === 'Pyro' ? pyroShift : 0) +
                (props.modalContent.element === 'Geo' ? geoShift : 0) +
                (props.modalContent.element === 'Hydro' ? hydroShift : 0)}px`
            }}
            classes={{
              root: clsx({
                [classes.lockInactive]: props.modalContent.constellation >= 4,
                [classes.lockActive]: props.modalContent.constellation < 4
              })
            }}
          />
          <Avatar
            style={{
              height: '45px',
              width: '45px',
              position: 'absolute',
              right: '226px',
              top: `${530 +
                (props.modalContent.element === 'Pyro' ? pyroShift : 0) +
                (props.modalContent.element === 'Geo' ? geoShift : 0) +
                (props.modalContent.element === 'Hydro' ? hydroShift : 0)}px`
            }}
            classes={{
              root: clsx({
                [classes.constellation]: props.modalContent.constellation >= 5,
                [classes.inactiveConstellation]:
                  props.modalContent.constellation < 5
              })
            }}
            src={get(
              _.find(characterAssets, { name: props.modalContent.name }),
              'constellation_5',
              'google'
            )}
            alt="5"
          />
          <LockIcon
            style={{
              height: '45px',
              width: '45px',
              position: 'absolute',
              right: '226px',
              top: `${530 +
                (props.modalContent.element === 'Pyro' ? pyroShift : 0) +
                (props.modalContent.element === 'Geo' ? geoShift : 0) +
                (props.modalContent.element === 'Hydro' ? hydroShift : 0)}px`
            }}
            classes={{
              root: clsx({
                [classes.lockInactive]: props.modalContent.constellation >= 5,
                [classes.lockActive]: props.modalContent.constellation < 5
              })
            }}
          />
          <Avatar
            style={{
              height: '45px',
              width: '45px',
              position: 'absolute',
              right: '279px',
              top: `${612 +
                (props.modalContent.element === 'Pyro' ? pyroShift : 0) +
                (props.modalContent.element === 'Geo' ? geoShift : 0) +
                (props.modalContent.element === 'Hydro' ? hydroShift : 0)}px`
            }}
            classes={{
              root: clsx({
                [classes.constellation]: props.modalContent.constellation >= 6,
                [classes.inactiveConstellation]:
                  props.modalContent.constellation < 6
              })
            }}
            src={get(
              _.find(characterAssets, { name: props.modalContent.name }),
              'constellation_6',
              'google'
            )}
            alt="6"
          />
          <LockIcon
            style={{
              height: '45px',
              width: '45px',
              position: 'absolute',
              right: '279px',
              top: `${612 +
                (props.modalContent.element === 'Pyro' ? pyroShift : 0) +
                (props.modalContent.element === 'Geo' ? geoShift : 0) +
                (props.modalContent.element === 'Hydro' ? hydroShift : 0)}px`
            }}
            classes={{
              root: clsx({
                [classes.lockInactive]: props.modalContent.constellation >= 6,
                [classes.lockActive]: props.modalContent.constellation < 6
              })
            }}
          />
        </Box>
        <Box
          component="img"
          src={EnkaIcon}
          style={{
            position: 'sticky',
            width: '180px',
            height: 'auto',
            marginTop: 'auto',
            marginLeft: 'auto'
          }}
        />
      </Container>
    </Modal>
  );
}

CharacterSnapshotModal.propTypes = {
  modalContent: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  rightBar: PropTypes.object
};

export default CharacterSnapshotModal;
